// Used to remove the skeleton animation and changes from the dom
export const removeSkeleton = () => {
  document
    .getElementById("board-carrousel-carrousel-wrapper")
    .querySelectorAll(".skeleton")
    .forEach((element) => {
      element.classList.remove("skeleton");
    });
};
